import { call, restService } from './apiHelpers';

export const duplicateService = {
  ...restService('duplicates'),
  createAssociationConflict: (payload) => call('post', 'duplicates/', payload),
  getForActor: (_, filters) => call('get', 'duplicates/', null, filters),
  addObservation: (id, observation) =>
    call('post', `duplicates/${id}/notes/`, { observation }),
  resolve: (id, payload) => {
    const paths = {
      keep_current: 'keep-current',
      reassign: 'reassign',
      share: 'share',
      reject: 'reject',
      invalid: 'mark-invalid',
    };
    return call('post', `duplicates/${id}/${paths[payload.resolution]}/`, {
      definitiveLeaderId: payload.definitiveLeaderId,
      notes: payload.notes,
    });
  },
  getSummary: () => call('get', 'duplicates/summary/'),
};
